import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

import { AuthContext } from '../App';
import { ProfessionalVerificationPanel } from '../components/ProfessionalVerificationPanel';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';


export default function IdentityVerification() {
  const navigate = useNavigate();
  const { API, user, language } = useContext(AuthContext);
  const title = language === 'de' ? 'Professionelle Verifizierung' : language === 'it' ? 'Verifica professionale' : language === 'fr' ? 'Vérification professionnelle' : 'Professional verification';
  return (
    <main className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 px-4 py-10" data-testid="identity-verification-page">
      <div className="mx-auto max-w-4xl space-y-6">
        <Button variant="ghost" onClick={() => navigate('/dashboard/professional')} data-testid="verification-back-dashboard-button"><ArrowLeft className="mr-2 h-4 w-4" />Dashboard</Button>
        <Card className="border-blue-100 shadow-lg">
          <CardHeader><CardTitle className="flex items-center gap-2 font-heading"><ShieldCheck className="h-6 w-6 text-blue-700" />{title}</CardTitle></CardHeader>
          <CardContent><ProfessionalVerificationPanel API={API} user={user} language={language} /></CardContent>
        </Card>
      </div>
    </main>
  );
}